import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Accordion({
  title,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-teal-100 rounded-lg mb-2 bg-white overflow-hidden shadow-sm" data-id="element-171">
      <button className="w-full px-4 py-3 flex justify-between items-center text-left font-medium text-slate-800 hover:bg-teal-50 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-172">
        <span className="pr-4" data-id="element-173">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-174" /> : <ChevronDown className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-175" />}
      </button>
      {isOpen && <div className="px-4 py-3 bg-slate-50 border-t border-teal-50 text-slate-600 text-sm" data-id="element-176">
          {children}
        </div>}
    </div>;
}